/*
 * Route guard for /app/* routes. Renders children when authenticated,
 * redirects to /app/login otherwise. Also waits for the auth store to finish
 * rehydrating from localStorage so we don't bounce the user to login on a
 * cold reload while we're still reading state.
 */

import { Fragment } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

export function AuthGate({ children }: { children: React.ReactNode }) {
  const { userId, isLoading, sessionGeneration } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="spinner" />
      </div>
    );
  }

  if (!userId) {
    return <Navigate to="/app/login" replace state={{ from: location }} />;
  }

  // Discard account-owned forms and pending screen state when the identity
  // changes, even when the URL stays the same during impersonation.
  return <Fragment key={sessionGeneration}>{children}</Fragment>;
}
